// extracted by mini-css-extract-plugin
export default {"heading":"yC","container":"zC","product_section_row":"AC","carousel":"BC","carouselwide":"CC","carouselwrapper":"EC","blockwrapper":"FC","product_carousel_row":"GC","headingnarrow":"HC","title":"IC"};
    if(module.hot) {
      // 1711717533400
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  